import {Component, Injector} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  readonly message: string = '';

  private readonly _close: (modalResponse?:boolean) => void = () => {/* void */};

  constructor(
      private injector: Injector,
  ) {
    try {
      const bottomSheetRef = injector.get(MatBottomSheetRef);
      this._close = modalResponse => { bottomSheetRef.dismiss(modalResponse) };
      this.message = injector.get<{message: string}>(MAT_BOTTOM_SHEET_DATA).message;
    } catch {}

    try {
      const dialogRef = injector.get(MatDialogRef);
      this._close = modalResponse => { dialogRef.close(modalResponse) };
      this.message = injector.get<{message: string}>(MAT_DIALOG_DATA).message;
    } catch {}
  }

  close(modalResponse?: boolean) {
    this._close(modalResponse);
  }
}
